import { h } from "preact";
import { Link } from "react-router-dom";

import { classNames, renderIcon } from "../helpers";

export default function IconLink({ children, ...props }) {
  let LinkTag = "a";
  if (props.to) {
    LinkTag = Link;
  }
  return (
    <LinkTag
      href={props.to}
      {...props}
      class={classNames("icon-link", props.class)}
    >
      {renderIcon(props.iconFront, "icon-link__frontIcon icon--small")}
      <span class="icon-link__content">{children}</span>
      {renderIcon(props.iconBack, "icon-link__backIcon icon--small")}
    </LinkTag>
  );
}
